export const serviceIconPaths = {
  skilledVisas: "/assets/service-page-section-icons/skilled-visas.png",
  skillsAssessment: "/assets/service-page-section-icons/skills-assessment.png",
  employerSponsored: "/assets/service-page-section-icons/employer-sponsored-visas.png",
  familyPartner: "/assets/service-page-section-icons/family-partner-visas.png",
  visitorTourist: "/assets/service-page-section-icons/visitor-tourist-visas.png",
  corporateImmigration: "/assets/service-page-section-icons/corporate-immigration.png",
} as const;

export type ServiceIconKey = keyof typeof serviceIconPaths;

export const getServiceIconPath = (key: ServiceIconKey) => serviceIconPaths[key];
